<script>
  import { createEventDispatcher } from 'svelte'

  export let trackingID
  export let add = 'select-none'
  export let text = 'Button'
  export let disabled = false

  const dispatch = createEventDispatcher()
  const defaultClass = 'w-1/4 text-white uppercase py-4 px-5 font-medium btn flex justify-center'

  $: classes = defaultClass + (disabled ? ' text-gray-500 select-none pointer-events-none disabled' : '')
</script>

<div data-tracking={trackingID}
     class={classes + ' ' + add}
     on:click={() => dispatch('click')}>
  {text}
</div>

<style>
.btn:hover {
  cursor: pointer;
}
.btn{
  background-color: #5992BA;
}
.disabled{
  background-color: rgb(209 213 219);
}
</style>
